import { useSessionStorage } from 'usehooks-ts';

type LocationHistory = {
  url: string;
  browser_time: string;
};

export const useGetLastDeviceUrlHistory = (): { lastDeviceHistoryTime: Date; lastDeviceHistoryUrlParams: string } => {
  const [deviceHistory] = useSessionStorage('location_history', [] as LocationHistory[]);
  const filteredDeviceHistory = deviceHistory.filter((history: LocationHistory) =>
    history.url.includes('gotoresolve.com/devices')
  );
  const lastDeviceHistory = filteredDeviceHistory?.[filteredDeviceHistory.length - 1];
  const lastDeviceHistoryTime = new Date(lastDeviceHistory?.browser_time ?? '');
  const lastDeviceHistoryUrl = lastDeviceHistory?.url ?? '';
  const lastDeviceHistoryUrlParams = lastDeviceHistoryUrl.split('?')[1];

  return { lastDeviceHistoryTime, lastDeviceHistoryUrlParams };
};
